import script from "./PackageDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageDetail.vue?vue&type=script&setup=true&lang=js"

import "./PackageDetail.vue?vue&type=style&index=0&id=1dd491ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dd491ef"]])

export default __exports__